import React from 'react';
import {StyledParagraph, StyledTitle} from "../CustomAntdComponents/Typography";
import {SelectInfoWrapper} from "./styles";

type Props = {
    isReturning: boolean;
    count: number;
    from: string;
    to: string;
}


const RoadSelectInfo = ({ isReturning, count, from, to }: Props) => {
    const title = isReturning ? 'Select your return from' : 'Select your departure from';
    return (
        <SelectInfoWrapper>
            <StyledTitle color='grey' level={4}>
                {/* {title} ({count}) */}
                {title}
            </StyledTitle>
            <StyledTitle level={4} style={{ marginTop: 0 }}>
                {from} to {to}
            </StyledTitle>
            {/* <StyledParagraph>
                Fares displayed are for all passengers
            </StyledParagraph> */}
        </SelectInfoWrapper>
    );
};

export default RoadSelectInfo;
